import React from 'react';
import { Camera, X, Upload } from 'lucide-react';
import { useImageUpload } from '../hooks/useImageUpload';

const ImageUpload = ({ label = "Foto", required = false }) => {
  const { imagePreview, isLoading, handleImageChange, removeImage } = useImageUpload();

  return (
    <div className="space-y-2">
      <label className="label">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      
      <div className="flex items-center space-x-4">
        {/* Preview da imagem */}
        {imagePreview && (
          <div className="relative">
            <img
              src={imagePreview}
              alt="Preview"
              className="w-24 h-24 object-cover rounded-lg border-2 border-gray-200"
            />
            <button
              type="button"
              onClick={removeImage}
              className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-colors"
            >
              <X size={16} />
            </button>
          </div>
        )}
        
        {/* Botão de upload */}
        <div className="flex-1">
          <label className="cursor-pointer">
            <div className={`
              border-2 border-dashed rounded-lg p-4 text-center transition-colors
              ${imagePreview 
                ? 'border-gray-300 bg-gray-50' 
                : 'border-primary-300 bg-primary-50 hover:border-primary-400 hover:bg-primary-100'
              }
            `}>
              {isLoading ? (
                <div className="flex items-center justify-center space-x-2">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-primary-600"></div>
                  <span className="text-primary-600">Carregando...</span>
                </div>
              ) : imagePreview ? (
                <div className="flex items-center justify-center space-x-2 text-gray-600">
                  <Camera size={20} />
                  <span>Alterar foto</span>
                </div>
              ) : (
                <div className="flex items-center justify-center space-x-2 text-primary-600">
                  <Upload size={20} />
                  <span>Selecionar foto</span>
                </div>
              )}
            </div>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="hidden"
              disabled={isLoading}
            />
          </label>
        </div>
      </div>
      
      <p className="text-xs text-gray-500">
        Formatos aceitos: JPG, PNG, GIF. Máximo 5MB.
      </p>
    </div>
  );
};

export default ImageUpload;
